import { render, staticRenderFns } from "./PromoteurForm.vue?vue&type=template&id=d5cc59d6&"
import script from "./PromoteurForm.vue?vue&type=script&lang=js&"
export * from "./PromoteurForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports